import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import React from 'react';
import {
	CLAIMS_CARD_OPEN_SUBCLAIMS_TITLE,
	CLAIMS_CARD_PENDING_CLAIMS_TITLE,
	CLAIMS_CARD_TITLE,
} from './constants';

export const ClaimsDataCard = ({ data }: any) => {
	const openClaims = parseInt(data.count_claims_open, 10) || 0;
	const pendingClaims = parseInt(data.count_claims_pending, 10) || 0;
	const openSubClaims = parseInt(data.count_subclaims_open, 10) || 0;

	return (
		<Card sx={{ width: { xs: 'auto', sm: 1 / 3 } }}>
			<CardContent>
				<Grid container justifyContent='space-between' spacing={3}>
					<Grid item style={{ width: '100%' }}>
						<Box
							display='flex'
							alignItems='center'
							justifyContent='space-between'
						>
							<Typography gutterBottom variant='subtitle1'>
								{CLAIMS_CARD_TITLE}
							</Typography>
							<Typography gutterBottom variant='subtitle1'>
								{openClaims.toLocaleString()}
							</Typography>
						</Box>
						<Box
							mt={2}
							display='flex'
							alignItems='center'
							justifyContent='space-between'
						>
							<Typography variant='subtitle2' color='textSecondary'>
								{CLAIMS_CARD_PENDING_CLAIMS_TITLE}
							</Typography>
							<Typography color='textSecondary' variant='subtitle2'>
								{pendingClaims.toLocaleString()}
							</Typography>
						</Box>
						<Box
							mt={2}
							display='flex'
							alignItems='center'
							justifyContent='space-between'
						>
							<Typography variant='subtitle2' color='textSecondary'>
								{CLAIMS_CARD_OPEN_SUBCLAIMS_TITLE}
							</Typography>
							<Typography color='textSecondary' variant='subtitle2'>
								{openSubClaims.toLocaleString()}
							</Typography>
						</Box>
					</Grid>
				</Grid>
			</CardContent>
		</Card>
	);
};
